import axios from 'axios';
import _ from 'lodash';

import cfg from '../config';

export const NEWS_GET_NEWS = "jobs/GET_NEWS";

const initialState = {
  messages: [],
  timestamp: Date.now(),
}

export default (state = initialState, action) => {
  switch (action.type) {
    case NEWS_GET_NEWS:
      return {
        ...state,
        messages: _.cloneDeep(action.data),
        timestamp: Date.now()
      }
    default:
      return state
  }
}

export const getNews = () => {
  return (dispatch, getState) => {
    axios.get(cfg.api.getNews)
    .then((response) => {
      dispatch({type: NEWS_GET_NEWS, data: response.data.messages });
    })
    .catch((error) => {
      console.log(error);
      dispatch({type: NEWS_GET_NEWS, data: []});
    });
  }
}



// WEBPACK FOOTER //
// ./src/reducers/news.js